import type { ID } from '@/model/Common.model';
import { type components } from '@/generated/internal-api/openapi-types';
import type { ExtendedMetadataItem, Errors } from './IndividualSaveRepeater.utils';

export type MetadataGlossaryFieldType = components['schemas']['MetadataGlossaryFieldType.schema'];

export interface ArchiveButtonProps {
  row: ExtendedMetadataItem;
  handleArchive: (id?: ID) => void;
  disabled?: boolean;
  unarchiveBlockedReason?: string;
}

export interface DeleteButtonProps {
  rowId?: ID;
  handleDelete: (id?: ID) => void;
  disabled?: boolean;
}

export interface IndividualSaveRepeaterProps {
  type: string;
  title: string;
  data: Array<ExtendedMetadataItem>;
  setData: (data: Array<ExtendedMetadataItem>) => void;
  errors: Array<Errors>;
  initialDataLookup: Record<ID, ExtendedMetadataItem>;
  hasLoaded: boolean;
  hasError: boolean;
  setFormErrors: (errors: Array<Errors>) => void;
  onRefreshGlobalData?: () => Promise<void>;
}

export interface AddCategoryProps {
  handleAdd: (field_type: MetadataGlossaryFieldType) => void;
  disabled?: boolean;
  type: string;
}

export const selectableFields: Record<MetadataGlossaryFieldType, string> = {
  select: 'Select',
  multi_select: 'Multi-select',
  date: 'Date',
  text: 'Text',
  numeric: 'Number',
} as const;
